/**
 * Created by augustocorvalan on 1/28/15.
 */
'use strict';

// ---------------------------------------------------
// Dependencies
var SoaModel = require('bunsen/models/SoaModel');
var Anchor = require('bunsen/models/Anchor');
var AnchorMember = require('bunsen/models/AnchorMember');
var Rule = module.exports = SoaModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var PromotionAnchorList = require('bunsen/models/PromotionAnchorList');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var endpoints = require('dibs-endpoints');
//Local Vars
var types;
var _matchApiType;

// ---------------------------------------------------
// Factory Methods
_matchApiType = function (arr) {
    return _.contains(arr, this.get('apiType'));
};

// ---------------------------------------------------
// Static Properties and Methods
types = {
    TYPE_BUYER_WHITE:       'buyerWhitelistRule',
    TYPE_BUYER_BLACK:       'buyerBlacklistRule',
    TYPE_DEALER_WHITE:      'dealerWhitelistRule',
    TYPE_DEALER_BLACK:      'dealerBlacklistRule',
    TYPE_ITEM_WHITE:        'itemWhitelistRule',
    TYPE_ITEM_BLACK:        'itemBlacklistRule',
    TYPE_VERTICAL_WHITE:    'verticalWhitelistRule',
    TYPE_PRICE_RANGE:       'priceRangeRule',
    TYPE_PURCHASE_HISTORY:  'purchaseHistoryRule',
    TYPE_VERIFIED_TRADE:    'verifiedTradeBuyerRule',
    TYPE_USES_PER_BUYER:    'usesPerBuyerRule',
    TYPE_USES_PER_CODE:     'usesPerCodeRule'
};

_.extend(Rule, types, {
    TYPE_WHITELIST:         [types.TYPE_DEALER_WHITE, types.TYPE_BUYER_WHITE, types.TYPE_ITEM_WHITE, types.TYPE_VERTICAL_WHITE],
    TYPE_BLACKLIST:         [types.TYPE_DEALER_BLACK, types.TYPE_BUYER_BLACK, types.TYPE_ITEM_BLACK],
    /**
     * @param {string} apiType
     * @param {string} name
     * @param {string} sourceType
     * @param {array} ids
     * @returns {object}
     */
    createRule: function (apiType, name, sourceType, ids, note) {
        return new Rule ({
            apiType: apiType,
            name: name,
            anchorList: PromotionAnchorList.createAnchorList(sourceType, ids, note)
        });
    },
    /**
     * @param {number} numberOfUses
     * @returns {Rule}
     */
    createUsesPerBuyerRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_BUYER,
            usesPerBuyer: numberOfUses
        });
    },

    createUsesPerCodeRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_CODE,
            usesPerCode: numberOfUses
        });
    },
    /**
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @returns {Rule}
     */
    createPurchaseHistoryRule: function (startDate, endDate) {
        var rule = new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY
        });

        if (startDate) {
            rule.set('historyStartDate', startDate);
        }

        if (endDate) {
            rule.set('historyEndDate', endDate);
        }

        return rule;
    },
    /**
     * @returns {Rule}
     */
    createVerifiedTradeRule: function () {
        return new Rule({ apiType : Rule.TYPE_VERIFIED_TRADE })
    },
    /**
     * @param {number} days
     * @returns {Rule}
     */
    createHistoryTimePeriodRule: function (days) {
        return new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY,
            historyTimePeriod: {
                numberOfUnits: days,
                timeUnit: 'DAY',
                calendarType: 'BASIC'
            }
        });
    },
    /**
     * @param {string} currency
     * @param {number} [minAmount]
     * @param {number} [maxAmount]
     * @returns {Rule}
     */
    createPriceRangeRule: function (currency, minAmount, maxAmount) {
        var rule = new Rule({
            apiType: Rule.TYPE_PRICE_RANGE
        });

        if (minAmount) {
            rule.set('minAmount', { currency: currency, amount: minAmount });
        }

        if (maxAmount) {
            rule.set('maxAmount', { currency: currency, amount: maxAmount });
        }

        return rule;
    }
});

// ---------------------------------------------------
// Instance Methods and Properties
_.extend(Rule.prototype, {
    relations: SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'anchorList',
            relatedModel: PromotionAnchorList
        },
        {
            type: Backbone.One,
            key: 'minAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'maxAmount',
            relatedModel: FinancialAmount
        }
    ]),
    getIds: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.getIds();
    },
    getIdTotalCount: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.get('totalSize');
    },
    getPriceRangeCurrency: function () {
        var min = this.get('minAmount');
        var max = this.get('maxAmount');

        return min && min.getCurrency() || max && max.getCurrency();
    },
    isPriceRangeCurrency: function (currency) {
        return this.getPriceRangeCurrency() === currency;
    },
    addIdsToCustomerList: function (ids, note) {
        var self = this;
        var members = AnchorMember.createAnchorMembers(Anchor.TYPE_USER, ids, note);

        return members.sync("create", members, {
            url: endpoints.promotionRuleAnchor(self.get('id'))
        });
    },
    isWhitelist:            _.partial(_matchApiType, Rule.TYPE_WHITELIST),
    isBlacklist:            _.partial(_matchApiType, Rule.TYPE_BLACKLIST),
    isItemListRule:         _.partial(_matchApiType, [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK]),
    isDealerListRule:       _.partial(_matchApiType, [Rule.TYPE_DEALER_BLACK, Rule.TYPE_DEALER_WHITE]),
    isBuyerListRule:        _.partial(_matchApiType, [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK]),
    isPriceRangeRule:       _.partial(_matchApiType, [Rule.TYPE_PRICE_RANGE]),
    isVerticalRule:         _.partial(_matchApiType, [Rule.TYPE_VERTICAL_WHITE]),
    isPurchaseHistoryRule:  _.partial(_matchApiType, [Rule.TYPE_PURCHASE_HISTORY]),
    isUsesPerBuyerRule:     _.partial(_matchApiType, [Rule.TYPE_USES_PER_BUYER]),
    isUsesPerCodeRule:      _.partial(_matchApiType, [Rule.TYPE_USES_PER_CODE])
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Rule.js
// module id = 177
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54